import request from '@/utils/request'

export function GetCategory(params){
  return request({
    url: 'wx/category',
    method: 'get',
    params
  })
}

export function SearchCategory(params){
  return request({
    url: 'wx/category/search-third',
    method: 'get',
    params
  })
}

export function GetCategoryUrl(id){
  return request({
    url: 'wx/survey/sync',
    method: 'post',
    data: {
      category_id: id
    }
  })
}

export function GetHotWord(type){
  let params = {}
  if(type||type===0){
    params={type: type}
  }
  return request({
    url: 'wx/category/hot-word',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/Evaluate.js


// WEBPACK FOOTER //
// ./src/api/Evaluate.js